import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import SportsTeamLogo from 'components/teamLogo';
import { _SPORTS_STATUS } from 'common/constants/sportsConstants';
import style from './style.module.scss';
import MajorViewOdds from '../odds';
import TextLengthTooltip from 'components/textLengthTooltip';
import moment from 'moment';
import { FormatUtil } from 'utils/formatUtil';

const MajorViewCard = observer(({ item, isSelected, setSelectedGame }) => {
  const {
    id,
    getTeamData,
    league,
    displayTime,
    startDatetime,
    getStartDateTime,
    statusText,
    teams,
    getTracker,
    betbleUri,
    videoLink,
    sportsType,
    gameStatus,
    oddsData,
    goalEvent,
    volleyBallPeriodScore,
    winnerTeam,
    getProgressTime,
    betbleButtonVisible,
    cheerCount
  } = item;
  const oddsOpenButtonRef = useRef();
  const [isOddsOpen, toggleOddsOpen] = useState(false);

  const onClickBetble = (event) => {
    event.stopPropagation();

    let type = 0;

    if (_SPORTS_STATUS[gameStatus] === 1) {
      type = 1;
    }

    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;

    window.open(url, 'betbel');
  };

  // const onClickVideo = () => {
  //   window.open(
  //     videoLink,
  //     `video_${id}`,
  //     'width=980px,height=750px,scrollbars=yes'
  //   );
  // };

  const onClickVideo = () => {
    // const videoWindow = window.open(
    //   `/live?url=${encodeURI(item.videoLink)}`,
    //   ``,
    //   "width=900px,height=426px,scrollbars=no"
    // );
    // Open the new window with a placeholder URL
    const videoWindow = window.open(
        `/live?url=${encodeURI(videoLink)}`,
        ``,
        "scrollbars=no"
    );
    // Ensure the window content has loaded, then resize the window based on the video size
    videoWindow.onload = () => {
      // Wait for the video element to be ready
      const videoElement = videoWindow.document.querySelector('video');

      // If the video element is found, we can proceed
      if (videoElement) {
        videoElement.onloadedmetadata = () => {
          // Get the natural dimensions of the video
          const videoWidth = videoElement.videoWidth;
          const videoHeight = videoElement.videoHeight;

          console.log('videoWidth', videoWidth);
          console.log('videoHeight', videoHeight);
          // Adjust the window size to match the video size
          // Add some padding to ensure the video fits nicely in the window
          videoWindow.resizeTo(videoWidth - 25, videoHeight + 40);
        };
      }
    };
  };

  const onClickNewWindow = (event) => {
    event.stopPropagation();
    let type = sportsType.toLowerCase();

    if (type === 'icehockey') {
      type = 'hockey';
    }

    window.open(
      `/match/${type}/${item.id}?20210308`,
      `detail_${type}_${item.id}`,
      'width=1000px,height=901px,scrollbars=yes'
    );
  };

  const setSelectedItem = (event) => {
    event.stopPropagation();

    setSelectedGame(isSelected, id, startDatetime, gameStatus, sportsType);
  };

  const formattedStartDateTime = moment(startDatetime).format('MM.DD HH:mm');
  return (
    <div className={style.score_board} onClick={onClickNewWindow}>
      <div className={style.summary_score}>
        {/* 헤더 */}
        <div className={clsx(style.info, style[getTracker.class])}>
          <span className={style.league_time}>
            <em>{formattedStartDateTime}</em>
            {league.shortName}
          </span>
          <span className={style.state}>
            {getTracker.status === 'progress' &&
              sportsType === 'SOCCER' &&
              getProgressTime.isActiveTime && (
                <strong
                  className={style.displayTime}
                >{`${getProgressTime.soccerTime}'`}</strong>
              )}
            {statusText}
            {getTracker.status === 'progress' &&
              gameStatus !== 'BREAK_TIME' &&
              (sportsType === 'BASKETBALL' || sportsType === 'ICEHOCKEY') && (
                <span className={style.displayTime}>{displayTime}</span>
              )}
          </span>
        </div>

        {/* 팀 */}
        <div className={style.team_area}>
          <div
            className={clsx(
              style.team,
              style.away,
              goalEvent.isActive &&
                goalEvent.location === 'away' &&
                style.highlight
            )}
          >
            <div className={style.logo}>
              <SportsTeamLogo
                imgSize={'35'}
                imgUrl={!!teams ? teams.away.imgPath : null}
                isLazy={true}
              />
            </div>
            <div className={style.name}>
              <TextLengthTooltip
                name={getTeamData.away.name}
                className={''}
                maxLength={8}
              />
            </div>
            <div
              className={clsx(
                style.point,
                winnerTeam.activeScore === 'away' && style.on
              )}
            >
              {sportsType === 'SOCCER' && getTeamData.isPk && (
                <span className={style.pk}>({getTeamData.away.pkScore})</span>
              )}
              {sportsType === 'ICEHOCKEY' && getTeamData.isShootout && (
                <span className={style.pk}>
                  ({getTeamData.away.shootoutScore})
                </span>
              )}
              {sportsType === 'VOLLEYBALL' ? (
                <>
                  {getTeamData.away.score}
                  {gameStatus === 'IN_PROGRESS' && (
                    <span>({volleyBallPeriodScore.away.score})</span>
                  )}
                </>
              ) : (
                getTeamData.away.score
              )}
            </div>
          </div>
          <div
            className={clsx(
              style.team,
              style.home,
              goalEvent.isActive &&
                goalEvent.location === 'home' &&
                style.highlight
            )}
          >
            <div className={style.logo}>
              <SportsTeamLogo
                imgSize={'35'}
                imgUrl={!!teams ? teams.home.imgPath : null}
                isLazy={true}
              />
            </div>
            <div className={style.name}>
              <TextLengthTooltip
                name={getTeamData.home.name}
                className={''}
                maxLength={8}
              />
            </div>
            <div
              className={clsx(
                style.point,
                winnerTeam.activeScore === 'home' && style.on
              )}
            >
              {sportsType === 'SOCCER' && getTeamData.isPk && (
                <span className={style.pk}>({getTeamData.home.pkScore})</span>
              )}
              {sportsType === 'ICEHOCKEY' && getTeamData.isShootout && (
                <span className={style.pk}>
                  ({getTeamData.home.shootoutScore})
                </span>
              )}
              {sportsType === 'VOLLEYBALL' ? (
                <>
                  {getTeamData.home.score}
                  {gameStatus === 'IN_PROGRESS' && (
                    <span>({volleyBallPeriodScore.home.score})</span>
                  )}
                </>
              ) : (
                getTeamData.home.score
              )}
            </div>
          </div>
        </div>

        {/* 버튼 */}
        <div className={style.btn_area}>
          <button
            className={clsx(style.btn, style.popup)}
            title="새창"
            onClick={onClickNewWindow}
          >
            새창
          </button>
          {/*{betbleButtonVisible && (*/}
          {/*  <button*/}
          {/*    className={clsx(style.btn, style.betting)}*/}
          {/*    title="베팅하기"*/}
          {/*    onClick={onClickBetble}*/}
          {/*  >*/}
          {/*    베팅*/}
          {/*  </button>*/}
          {/*)}*/}
          {!!videoLink && ( gameStatus === "IN_PROGRESS" || gameStatus === "BREAK_TIME" || gameStatus === "PAUSE" ) && (
            <button
              className={clsx(style.btn, style.onair)}
              title="생중계"
              onClick={onClickVideo}
            >
              생중계
            </button>
          )}
          {cheerCount >= 100 && (
            <div className={style.cheer_count}>
              {FormatUtil.numberUnitConvert(cheerCount)}
            </div>
          )}
          <button
            className={clsx(style.btn_ud, isSelected ? style.down : style.up)}
            onClick={setSelectedItem}
          >
            올리기/내리기
          </button>
        </div>

        {/* 배당 정보 */}
        {isOddsOpen && (
          <MajorViewOdds
            oddsData={oddsData}
            team={getTeamData}
            closeOdds={toggleOddsOpen}
            oddsOpenButtonRef={oddsOpenButtonRef}
          />
        )}
      </div>
    </div>
  );
});

export default MajorViewCard;
